// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + ".2437468c9bea8069." + "1241f135" + ".chunk.js";
};